export default __webpack_public_path__ + "static/media/job-board-bg-bottom.d2e1b13b.png";